import { configureStore } from '@reduxjs/toolkit'
import userSessionReducers from './features/session/userSession';
import appStateReducers from './features/appState';

const store = configureStore({
  reducer: {
    appState: appStateReducers,
    userSession: userSessionReducers,
  },
  devTools: (process.env.NODE_ENV !== 'production'),
})

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;